import React from "react";
import { Label as RLabel, Flex, Box } from "rebass";
import styled from "styled-components";
import Link from "gatsby-link";
import Image from "../../components/image";

const ProjectThumb = styled.div`
  opacity: ${({ opacity }) => opacity};
  img {
    width: ${({ w }) => w};
  }
`;

const Label = styled(RLabel)`
  text-align: center;
`;

export default ({
  project,
  w,
  opacity,
  labelProps,
  onMouseEnter,
  onMouseLeave,
  onLoad
}) => {
  return (
    <Link key={project.slug} to={`/projecten/${project.slug}`}>
      <Flex justify="center" align="center" column>
        <Box w={w}>
          <ProjectThumb
            name="projectThumb"
            key={project.slug}
            opacity={opacity}
          >
            <Image
              onLoad={onLoad}
              file={project.bannerImage}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            />
          </ProjectThumb>
        </Box>
        {labelProps && (
          <Box>
            <Label f={labelProps.f} mt={labelProps.mt}>
              {project.title}
            </Label>
          </Box>
        )}
      </Flex>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/feed/project-thumbnail.js